import React from 'react';
import { ArrowLeft, Info, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import NearbyAreas from './NearbyAreas';
import AreaDedicatedArticle from '../AreaDedicatedArticle';
import AreaRelatedArticles from '../AreaRelatedArticles';

const GovernorateTemplate = ({ areaData, displayName, phone, brand, images }) => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
      {/* Header Section */}
      <header id="header" className="area-hero-header" style={{
        background: 'linear-gradient(135deg, #0277bd 0%, #00acc1 100%)',
        color: 'white',
        borderRadius: '1.5rem',
        padding: '3rem 2rem',
        marginBottom: '2rem',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        marginTop: '2rem'
      }}>
        <nav aria-label="الرجوع إلى قائمة المناطق">
          <Link to="/areas" style={{
            position: 'absolute', top: '1rem', left: '1rem', color: 'white',
            textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.5rem',
            fontSize: '1rem', fontWeight: 600
          }}>
            <ArrowLeft size={20} /> المناطق
          </Link>
        </nav>
        <nav aria-label="مسار التنقل" style={{ fontSize: '0.95rem', marginBottom: '1rem', opacity: 0.95, direction: 'rtl', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
          <Link to="/" style={{ color: '#ffc107', textDecoration: 'none', fontWeight: 700 }}>الرئيسية</Link>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}>/</span>
          <Link to="/areas" style={{ color: '#ffc107', textDecoration: 'none', fontWeight: 700 }}>مناطق الخدمة</Link>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}>/</span>
          <span style={{ color: '#ffffff', fontWeight: 800 }}>ونش انقاذ {displayName}</span>
        </nav>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: '1rem', direction: 'rtl' }}>
          نقل وإنقاذ السيارات من وإلى {displayName}
        </h1>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
          background: 'rgba(255,255,255,0.2)', padding: '0.5rem 1.2rem',
          borderRadius: '2rem', fontSize: '1.1rem', fontWeight: 700,
          marginBottom: '1rem', direction: 'rtl'
        }}>
          <MapPin size={20} color="#e1f5fe" />
          <span>خدمة النقل بين المحافظات - 24 ساعة</span>
        </div>
        <p style={{ fontSize: '1.2rem', opacity: 0.95, maxWidth: '750px', margin: '0 auto 1rem auto', direction: 'rtl', lineHeight: 1.8 }}>
          {areaData.intro}
        </p>
      </header>

      {/* Inter-City Transport Specific */}
      <section id="local-coverage" aria-labelledby="coverage-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '1px solid #ddd', direction: 'rtl' }}>
        <h2 id="coverage-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0277bd', marginBottom: '1.5rem', textAlign: 'center' }}>
          نطاق الخدمة في {displayName}
        </h2>
        <p style={{ fontSize: '1.1rem', lineHeight: 1.8, marginBottom: '1rem' }}>
          نوفر أسطولاً من الأوناش المتخصصة للسفر الطويل لنقل سيارتك من القاهرة إلى {displayName} أو العكس، بأمان تام ومع تأمين شامل على السيارة أثناء رحلة النقل على الطرق الزراعية والصحراوية.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
          <article style={{ background: '#f8f9fa', padding: '1.2rem', borderRadius: '1rem', border: '1px solid #e9ecef' }}>
            <h3 style={{ fontSize: '1.15rem', fontWeight: 700, color: '#00acc1', marginBottom: '0.8rem' }}>المراكز والطرق المخدومة:</h3>
            <ul style={{ paddingRight: '1.2rem', margin: 0, lineHeight: 1.8 }}>
               {areaData.landmarks.map((lm, i) => <li key={i}>{lm}</li>)}
            </ul>
          </article>
        </div>
      </section>

      {/* Local Notes / Safety */}
      {areaData.localNotes && areaData.localNotes.length > 0 && (
        <aside aria-label="معلومات وإرشادات الطريق" style={{ background: '#e1f5fe', borderRight: '4px solid #0277bd', padding: '1.5rem', borderRadius: '0.5rem', marginBottom: '2rem', direction: 'rtl' }}>
          <h3 style={{ color: '#0277bd', display: 'flex', alignItems: 'center', gap: '0.5rem', margin: '0 0 1rem 0' }}><Info size={24} /> معلومات الطريق:</h3>
          <ul style={{ margin: 0, paddingRight: '1.2rem', lineHeight: 1.8 }}>
             {areaData.localNotes.map((note, i) => <li key={i}>{note}</li>)}
          </ul>
        </aside>
      )}

      {/* Dedicated Supporting Article Section */}
      <AreaDedicatedArticle
        areaData={areaData}
        displayName={displayName}
        templateType="Governorate"
        phone={phone}
      />

      {/* Related Supporting Articles & Pillar Guides */}
      <AreaRelatedArticles areaName={displayName} />

      {/* FAQ */}
      {areaData.faqs && areaData.faqs.length > 0 && (
        <section id="faq" aria-labelledby="faq-heading" style={{ background: 'white', borderRadius: '1.5rem', padding: '2rem', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', marginBottom: '2rem', border: '1px solid #ddd', direction: 'rtl' }}>
          <h2 id="faq-heading" style={{ fontSize: '1.5rem', fontWeight: 800, color: '#0277bd', marginBottom: '1.5rem', textAlign: 'center' }}>الأسئلة الشائعة لخدمات المحافظات</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {areaData.faqs.map((faq, index) => (
              <article key={index} style={{ borderBottom: '1px solid #eee', paddingBottom: '1rem' }}>
                <h3 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#00acc1', marginBottom: '0.5rem' }}>{faq.q}</h3>
                <p style={{ margin: 0, color: '#555', lineHeight: 1.6 }}>{faq.a}</p>
              </article>
            ))}
          </div>
        </section>
      )}

      {/* Nearby Areas — Internal Linking */}
      <NearbyAreas nearby={areaData.nearby} accentColor="#0277bd" />
    </div>
  );
};
export default GovernorateTemplate;
